<!-- Full-screen click catcher for dismissing primary modal -->
@if (onboardingProvider.showPrimaryModal) {
  <div
    class="onboarding-click-backdrop"
    (click)="onOverlayClick($event)">
  </div>
}

<div [ngClass]="{'onboarding-modal-overlay': windowService.isDesktopRes, 'onboarding-modal-overlay-mobile': !windowService.isDesktopRes}" [style.visibility]="onboardingProvider.loaded ? 'visible' : 'hidden'">
  <div [ngClass]="{'onboarding-modal-container': windowService.isDesktopRes, 'onboarding-modal-container-mobile': !windowService.isDesktopRes}">
    <div style="position: relative; pointer-events: auto;">

      <!-- Main onboarding content -->
      @if (onboardingProvider.showPrimaryModal) {
        <div>
          <div [ngClass]="{'onboarding-modal-header': windowService.isDesktopRes, 'onboarding-modal-header-mobile': !windowService.isDesktopRes}">
            <tidy-row [alignLastItemRight]="true">
              @if (onboardingProvider.showBackButton) {
                <tidy-icon
                  class="onboarding-back-button"
                  [size]="20"
                  (click)="goBack()"
                  name="arrow-back-white" />
              }
              @if (!windowService.isDesktopRes && !onboardingProvider.showBackButton && onboardingProvider.flow !== 'pickYourGoals') {
                <tidy-image
                  [src]="'assets/img/menu-close-white.svg'"
                  (click)="closeModal()"
                  style="width: 20px; margin-right: 10px; margin-left: -5px" />
              }
              <tidy-text
                [title]="onboardingProvider.title"
                class="white" />
              @if (windowService.isDesktopRes) {
                <tidy-text
                  [actionBody]="'Free Setup Call'"
                  class="link white"
                  (action)="openScheduleCallModal()" />
              }
              @if (!windowService.isDesktopRes) {
                <div style="margin-right: -5px">
                  <tidy-icon
                    [size]="25"
                    (click)="openScheduleCallModal()"
                    name="help-circle-outline-white" />
                </div>
              }
            </tidy-row>
            <tidy-row [ngStyle]="onboardingProvider.showBackButton || (!windowService.isDesktopRes && onboardingProvider.flow !== 'pickYourGoals') ? {'margin-left': '25px'} : {}">
              <tidy-text
                [body]="onboardingProvider.subTitle"
                class="white" />
            </tidy-row>
          </div>
          <div [ngClass]="{'onboarding-content-area': windowService.isDesktopRes, 'onboarding-content-area-mobile': !windowService.isDesktopRes}">
            @if (onboardingProvider.page === 'pickYourGoals') {
              <pick-your-goals />
            }
            @if (onboardingProvider.page === 'goals') {
              <onboarding-goals />
            }
            <!--Used In Multiple Flows-->
            @if (onboardingProvider.page === 'directIntegration') {
              <tidy-direct-integration-onboarding />
            }
            @if (onboardingProvider.page === 'addDirectIntegration') {
              <tidy-add-direct-integration-onboarding />
            }
            @if (onboardingProvider.page === 'createConciergeAction') {
              <create-concierge-action-onboarding />
            }
            <!--Property-->
            @if (onboardingProvider.page === 'property') {
              <tidy-property-onboarding />
            }
            @if (onboardingProvider.page === 'importCSV') {
              <tidy-import-csv-onboarding />
            }
            <!--tidy-direct-integration-onboarding-->
            <!--tidy-add-direct-integration-onboarding-->
            <!--Schedule-->
            <!-- <schedule-onboarding *ngIf="onboardingProvider.page === 'schedule'"></schedule-onboarding> -->
            <!--Message Automation-->
            @if (onboardingProvider.page === 'messageAutomation') {
              <enable-concierge-messaging-onboarding />
            }
            <!--Notify Pros of Change-->
            @if (onboardingProvider.page === 'notifyProsOfChange') {
              <notify-pros-of-change-onboarding />
            }
            <!--Tasks-->
            @if (onboardingProvider.page === 'tasks') {
              <tasks-onboarding />
            }
            <!--To-Do List-->
            @if (onboardingProvider.page === 'toDos') {
              <to-dos-modal-onboarding />
            }
            @if (onboardingProvider.page === 'popularList') {
              <popular-list-modal-onboarding />
            }
            <!--Inventory Automation-->
            @if (onboardingProvider.page === 'inventoryAutomation') {
              <select-restocking-option />
            }
            @if (onboardingProvider.page === 'restocking') {
              <tidy-restocking-onboarding />
            }
            <!--create-concierge-action-onboarding-->
            <!--Add Appliance-->
            @if (onboardingProvider.page === 'selectMaintenance') {
              <select-maintenance-option-onboarding />
            }
            @if (onboardingProvider.page === 'addMaintenanceItems') {
              <add-maintenance-items-onboarding />
            }
            <!--create-concierge-action-onboarding-->
            <!--Bills-->
            @if (onboardingProvider.page === 'bills') {
              <bills-onboarding />
            }
            <!--Add Pros-->
            @if (onboardingProvider.page === 'addPros') {
              <tidy-add-pros-onboarding />
            }
            <!--create-concierge-action-onboarding-->
            <!--Automatic Booking-->
            @if (onboardingProvider.page === 'enableAutomaticBooking') {
              <enable-automatic-booking-onboarding />
            }
            <!--create-concierge-action-onboarding-->
            <!--Integrate-->
            @if (onboardingProvider.page === 'selectIntegration') {
              <select-integration-onboarding />
            }
            <!--tidy-direct-integration-onboarding-->
            <!--tidy-add-direct-integration-onboarding-->
            <!--Access Notes-->
            @if (onboardingProvider.page === 'selectAccessNotes') {
              <select-access-notes-option-onboarding />
            }
            @if (onboardingProvider.page === 'inputAccessNotes') {
              <input-access-notes-onboarding />
            }
            <!--Find New Pros-->
            @if (onboardingProvider.page === 'selectFindNewPros') {
              <select-find-new-pros-option-onboarding />
            }
            <!--Guest Smart Number-->
            @if (onboardingProvider.page === 'enableGuestSmartNumber') {
              <enable-guest-smart-number-onboarding />
            }
            <!--Customize Your Workflows-->
            @if (onboardingProvider.page === 'automateWorkflows') {
              <automate-workflows-onboarding />
            }
            <!--Create Rules-->
            @if (onboardingProvider.page === 'createConciergeRules') {
              <create-concierge-rules-onboarding />
            }
            <!--Integrate Upsell Provider-->
            @if (onboardingProvider.page === 'upsell') {
              <integrate-upsell-provider />
            }
            <!--Add Inspections-->
            @if (onboardingProvider.page === 'addInspections') {
              <add-inspections-onboarding />
            }
            <!--Customize Service Names-->
            @if (onboardingProvider.page === 'customizeServiceNames') {
              <service-rename-onboarding />
            }
          </div>
        </div>
      }

      <!-- Secondary content shown when user lands on the page -->
      @if (!onboardingProvider.showPrimaryModal) {
        <div class="secondary-content" [ngClass]="{'secondary-content-mobile': !windowService.isDesktopRes}">
          <tidy-row [align]="'center'" [ngStyle]="windowService.isDesktopRes ? {'margin-bottom': '30px'} : {'margin-bottom': '10px'}">
            @if (windowService.isDesktopRes) {
              <tidy-text
                [heroBody]="onboardingProvider.description"
                class="white" />
            }
            @if (!windowService.isDesktopRes) {
              <tidy-text
                [largeBody]="onboardingProvider.description"
                class="white" />
            }
          </tidy-row>
          <tidy-button
            [text]="onboardingProvider.buttonText"
            (click)="handleButtonClick()"
            class="primary full-width" />
        </div>
      }
    </div>

  </div>
</div>